import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import PlansList from "../../components/home/membershipPlanComponents/PlansList";
import SectionHeader from "../../components/home/membershipPlanComponents/SectionHeader";
import { fetchCurrentSubscription } from "../../features/subscriptionSlice";

const MembershipPlans = () => {
  const dispatch = useDispatch();
  const userId = useSelector((state) => state.auth.user?.userId);
  const { subscription, history } = useSelector((state) => state.subscription);

  // Fetch current subscription to determine if user has active subscription
  useEffect(() => {
    if (userId) {
      dispatch(fetchCurrentSubscription(userId));
    }
  }, [dispatch, userId]);

  // Determine subscription type based on subscription status
  const determineSubscriptionType = () => {
    if (subscription) {
      // User has active subscription - this is a plan change
      return "CHANGE_PLAN";
    } else if (history && history.length > 0) {
      // User has subscription history but no active subscription - this is a renewal
      return "RENEW";
    } else {
      // User has never had a subscription - this is new
      return "NEW";
    }
  };

  const subscriptionType = determineSubscriptionType();

  return (
    <div className="bg-gradient-to-b from-[#FFF7F2] to-[#FEF8ED] min-h-screen">
      {/* Section Header */}
      <SectionHeader
        title="Membership Plans"
        placeholder="Search plans…"
        onChange={(val) => console.log("search", val)}
      />

      <div className="px-6 py-16 pb-12">
        <PlansList subscriptionType={subscriptionType} />
      </div>
    </div>
  );
};

export default MembershipPlans;
